export default "__VITE_ASSET__CcnNPqw7__"